import {Navigate} from 'react-router-dom';
import useUserInfoStore from "../../../services/user_info";

interface ProtectedRouteProps {
    children: React.ReactNode;
    allowedRoles?: Array<'ADMIN' | 'CLIENT'>;
}

export const ProtectedRoute = ({ children, allowedRoles }: ProtectedRouteProps) => {
    const userInfo = useUserInfoStore((state) => state.userInfo);

    // 로그인하지 않은 경우
    if (!userInfo || !userInfo.userName || userInfo.role === '') {
        // 현재 시도한 페이지 URL을 state로 전달하여 로그인 후 리다이렉션 가능하게 함
        return <Navigate to="/login" replace />;
    }

    // 권한이 필요한 페이지에 대한 검사
    if (allowedRoles && !allowedRoles.includes(userInfo.role)) {
        // 권한이 없는 경우 각 역할별 메인 페이지로 리다이렉션
        if (userInfo.role === 'ADMIN') {
            return <Navigate to="/admin" replace />;
        }
        if (userInfo.role === 'CLIENT') {
            return <Navigate to="/client" replace />;
        }
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};